import { buildQueryHelpers, OperationIds } from '../../util'
import { AllQueriesForResource } from '../../util/types'
import {
  insertNew,
  updateAttributes,
  removeDeleted,
  insertBlock,
  insertBlockResolvingOverlaps,
  createPlaceholderBlock,
  deleteSwimlane,
  insertCategory,
  createPlaceholderCategory,
  insertChart,
  updateCategory,
  updateBlock,
  resolveOverlappingBlocks,
  addBlockToCategory,
  removeBlockFromCategory,
  changeBlockCategory,
  createBlockCustomFieldValue,
  replaceTempId,
  updateBlockCustomFieldValue,
  deleteBlockCustomFieldValue,
  tempCFVId,
} from './cacheTransformFns'
import { createPlaceholderChart } from './cacheTransformFns/insertChart'
import { PlanKey, PlansCollectionKey } from './types'
import { useReadPlan } from './useReadPlan'
import { getReadPlansQueryFn, useReadPlans } from './useReadPlans'

export type { BlockCustomFieldValueType } from './cacheTransformFns'
export { plans } from './requests'
export { getReadPlansQueryFn }

export const prePlanningBlockKey = 'preplanning_blocks'
export const noCategoryKey = 'no_category'

export const allPlansQueries = {
  ...buildQueryHelpers<OperationIds.ReadPlansBFFV1, AllQueriesForResource>(
    'plan',
    null
  ),
}

export const readPlansCollection = {
  ...buildQueryHelpers<OperationIds.ReadPlansBFFV1, PlansCollectionKey>(
    'plan',
    OperationIds.ReadPlansBFFV1
  ),
  getEnsureQueryData: getReadPlansQueryFn,
  transformCache: {
    insertNew,
    removeDeleted,
  },
  useQuery: useReadPlans,
}

export const readPlan = {
  ...buildQueryHelpers<OperationIds.ExperimentalReadPlanBFFV1, PlanKey>(
    'plan',
    OperationIds.ExperimentalReadPlanBFFV1
  ),
  transformCache: {
    deleteSwimlane,
    insertBlock,
    insertBlockResolvingOverlaps,
    insertCategory,
    insertChart,
    createPlaceholderCategory,
    updateBlock,
    resolveOverlappingBlocks,
    addBlockToCategory,
    removeBlockFromCategory,
    changeBlockCategory,
    createPlaceholderBlock,
    createPlaceholderChart,
    updateAttributes,
    updateCategory,
    createBlockCustomFieldValue,
    replaceTempId,
    updateBlockCustomFieldValue,
    deleteBlockCustomFieldValue,
    tempCFVId,
  },
  useQuery: useReadPlan,
}
